import { generateRoutes } from 'utils/generateRoutes';

export const mfaSetupRoutes = generateRoutes({}, 'mfa-setup');

